import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarGeral from "../assets/images/geral-avatar.png";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Geral() {
    useTrackPageView();
    useTimeOnPage();

    const handleWhatsappClick = async () => {

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "leads",
            category: "whatsapp",
            action: "click",
            label: "geral_cta_main",
        });


        await trackEvent("whatsapp_click", {
            buttonLocation: "masculino_cta_main",
        });

        window.open("https://sendwich.pro/grupos/promosperfumesoriginais", "_blank");
    };
    return (
        <LandingCategory
            avatar={avatarGeral}
            titleTop="CHEGA DE"
            titleBottom="PAGAR CARO EM PERFUMES!"
            highlightWord="PAGAR CARO EM PERFUMES!"
            members="100.000"
            description="Entre no nosso grupo VIP e receba as melhores promoções da internet todos os dias!"
            whatsappLink="https://sendwich.pro/grupos/promosperfumesoriginaiss"
            telegramLink="https://t.me/seu-link"
            theme={themes.geral}
            onWhatsappClick={handleWhatsappClick}
        />
    );
}